var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _image, _image2, _image3, _image4, _image5, _image6, _image7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLightBulb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 67 68",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.227,
    cy: 33.242,
    rx: 33.227,
    ry: 33.242,
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("g", null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 17.353,
    y: 12.697,
    width: "34.828px",
    height: "43.748px",
    transform: "matrix(0.9951,0,0,0.99427,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.358,28.626c0,-6.022 4.889,-10.91 10.91,-10.91c6.021,0 10.909,4.889 10.909,10.91l0,0.1c-0.048,8.51 -6.19,12.392 -6.19,18.732l-9.439,0c0,-6.364 -6.19,-10.252 -6.19,-18.832Z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.39,21.601c3.848,0.016 7.048,2.694 7.853,6.27",
    style: {
      fill: "none",
      stroke: "#fce8b6",
      strokeWidth: 2
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 24.43,
    y: 44.975,
    width: "21.236px",
    height: "15px",
    transform: "matrix(0.965264,0,0,1,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.702,51.061l9.131,0",
    style: {
      fill: "url(#_Linear4)",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image5",
    x: 7.269,
    y: 23.928,
    width: "15.341px",
    height: "14px",
    transform: "matrix(0.958784,0,0,1,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.638,29.513l5.175,0",
    style: {
      fill: "url(#_Linear6)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image7",
    x: 12.373,
    y: 8.294,
    width: "14.716px",
    height: "14.716px",
    transform: "matrix(0.981097,0,0,0.981097,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.744,12.742l3.66,3.66",
    style: {
      fill: "url(#_Linear8)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 27.689,
    y: 2.287,
    width: "14px",
    height: "15.341px",
    transform: "matrix(1,0,0,0.958784,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.275,5.861l0,5.175",
    style: {
      fill: "url(#_Linear10)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image11",
    x: 42.342,
    y: 9.294,
    width: "14.716px",
    height: "13.735px",
    transform: "matrix(0.981097,0,0,0.981097,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.806,12.742l-3.66,3.66",
    style: {
      fill: "url(#_Linear12)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image5",
    x: 48.992,
    y: 23.928,
    width: "15.341px",
    height: "14px",
    transform: "matrix(0.958784,0,0,1,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.816,29.513l-5.176,0",
    style: {
      fill: "url(#_Linear13)",
      stroke: "#fff",
      strokeWidth: 2
    }
  }), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 24.43,
    y: 48.444,
    width: "21.236px",
    height: "15px",
    transform: "matrix(0.965264,0,0,1,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.702,54.529l9.131,0",
    style: {
      fill: "url(#_Linear14)",
      stroke: "#fff",
      strokeWidth: 3
    }
  }), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image15",
    x: 26.219,
    y: 52.012,
    width: "16.741px",
    height: "14.971px",
    transform: "matrix(0.984754,0,0,0.998079,-4.54747e-13,0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.615,57.998c-0.52,0.586 -1.378,0.969 -2.347,0.969c-0.97,0 -1.828,-0.383 -2.348,-0.969l4.695,0Z",
    style: {
      fill: "url(#_Linear16)",
      stroke: "#fff",
      strokeWidth: 3
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,3.41061e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "35px",
    height: "44px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAsCAYAAADvjwGMAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACtElEQVRYhcWYwVHkMBBF2/bsxsKZMzmQBEEQAkGQBDlw5k4qyxhxwK36/vottadctapSyTBS6+l3S255soPl+elxyvZ9eX0rR2ynDQMEjlHjC7VpsCEMQUTPCqR5HgGFMAKiVxFmVEMoCSNA5q2qZ++LSnxDLfQcAjUwBDJTXbaKQEoZn3zd6re1gA3QDiYAWYI6glmDGgJdWBkBcoGKMN7Px7hRn8gnv9renUb9allIFa8+oUP82SpCIdxsrftUXGEpZmYP93f2/vFpBivrqYIQDMQgahH8zNA1PC5CFY4VdhPGijoAPW74d7M2iL1fqTBgDN2kXLJbkZgMbfHWLZsdBJqw7yRi5WJmf+1XVm9ZlR6IT+yt76yrmX2Z2T9or9tvxcwKxkzkJnWmjF4jfEKnzimG4UPuFpAIrGd7B8OBmHkPHQEZ2ZoQZjTwjDK0r84Z404nACnlG7sM818Lw6jk6OzCiVcIwx12SdEJAGx7V2bR2Q8qBXEWFNqv88yiY3fAjZOn7KqY4awsUukoUGS3lnnLtBS9GnQEigM1WmAxs/Ly+laUm9QKvN5SevaGbuIcVq5kAMBKqgS9sTOb1aRYKSOT6GTJ3BSqiypMYGANjMgDi2x4q0D6ygxWowxk3BQpHe7QCgP3l17cZN2lVJEgeG+KXgeZwItO6Gi8t6G6C/7x/vFpD/d36nUf3bU5tcCJPO/19kpAzfVW3SjZKCqzwGonaHncaEdKNy/8D1IHlcG2pwgCuCIMJL9CRMpEK10BqBgl1NTXIdLvt0YZs6qOWZyGKlDeOaiKx8vukOOSVWa1VoHMJxFUZ6jMETfhtkR3ZQI4BdPN+unqq7Y42/DJfPLmJdv7yDi8ggig0e2ST/IUSAoGgLB/Fqa2p3wHFkCj8c2k2S/lN98Ue5/tj36m9/IDif4Q5IbZWgMAAAAASUVORK5CYII="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "22px",
    height: "15px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAPCAYAAADgbT9oAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAuUlEQVQ4jb2U0Q2DMAxELxH7dYkO0REYgiVYMPQDiM7Xc+AD1ZLliCTPF+OkYGCf96uM5gFgXtbNff/ZaGAjeIBykrCJoFl0UI2Yl3WbBMogdQdmDwmLUVolKpwVnt4koisWQBXPFLfDccSefJLFGVzL4Y5/rtkVJy2V1dqts3M16UNXxysPpqXQH6InYNMfFhIwmFU2Gd/tig7vSh7o43BRXCl4fOfmcRIA+837z1vhbPTCZS8bAHwBLShnbDz7uvwAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,1.56319e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    id: "_Image5",
    width: "16px",
    height: "14px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAmklEQVQokaWTsQ2AMAwEbWAYamp2YIkMwQgMwRLsQE3PMpjKkfnEBomXUCLiP78ihyjQnCae08RRzePwrVi1rJsUAGPGVSV2VQhXzEwlxJrFQtgxI0icjzqIqabGAVyQKAMwNiawDcSCG/opTaCRtINAncB/9w604KL4ErPa/ThpHPraABXdELKsm0SDhHt/kCqQUHaUQ315TDca1UfDAP2hpgAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,1.98952e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    id: "_Image7",
    width: "15px",
    height: "15px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAqUlEQVQokY1TwQ2EQAicXS3m3r6vB5uwCEuwCJuwh3v7txm5z7GBOVBJDJvADDMEgSTmaSxZTcM13AGWdZMQbIARQQNZghIAmURMFktQSYV+1eRKtTasDyS6xl/WqaeqmKex9LQklm+ln2yl8gYTBZEa57kxXoQlcJ4F3p9Q7Y+cF2abrMeQoAOAz37gPbyuriuc3OkjIcikCxCc4s2ZNpJl3SRsePqDfAHDGj+vk26NzwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,1.7053e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "14px",
    height: "16px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAqElEQVQokZWTwQ3CMAxFv5MO0zNndmCJDtERGIIlugNn7izTcMGR8+pKYMlK4+TZ/mligq3LzRiTpPtja3E+bALk3x2IsCUQR4dbhC2BDFAEOzyhNfrQapxPCDpQAO5MUgCdVT7otqCvwFkx+lDxL6vP11vXy8x2sl/h+hpPtX2BuEmEPMhT9YVdo0YmEytmSVK4SlLQeQb10a9c9dUEPiRJL7nbr8/qA8TMTs5pQWEKAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,1.98952e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    id: "_Image11",
    width: "15px",
    height: "14px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAn0lEQVQokY2TwQ3CMAxFn0mH4cyZHbpEh2CEDtElugNn7kxjLk1wbKdgyYqS+Nk/X4qQxGOZJTuvsW67AoQiB2ZNtDboLg0oBhQLHasClBNQgMuRqYrJ7S3kp9vJX/hkaia5NaqSrCwZZJBuYVxhFs0sgPLDYQ917y7P15v77ToCdZBAdBtycwK8brtOCZSBeLCT6N4+UtPAUPjvh6jxAZRWQIZ46HvTAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,4.54747e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,1.98952e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,2.55795e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    id: "_Image15",
    width: "17px",
    height: "15px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAwklEQVQ4jZVTyRGDMAxcmRSTd97pgSYoghIogiboIW/+acbmgcWsZBFPNKORD+16pZGBjs3TKPM0yq+c5rIHUFvWrTQkDiz+nqxUv8gegTJ2JioU2c8EUpHqGUe2XIEcwUqEgOysRBRYowBoylGyBGAISBCskagU3wevjMs0+ZESfYkbGZ1fNnz2L96vZ6RAArA2M9O+UcKJuueeNASeRA+zAzEJP2LnBDCz8s+wYVm3Ysb6ZvS9mZG/Tex9Qv58AHAAOtRR0lF2Pg8AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(33.2269,66.4836,-66.4836,33.2269,33.2269,2.55795e-13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fce8b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#fde4c2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#fedadd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ffd0fa",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightBulb);
export default __webpack_public_path__ + "static/media/icon-light-bulb.0b4649361993f6b5581cf7e2da9e4be9.svg";
export { ForwardRef as ReactComponent };